// Connects the Move to Referral Management modal component with the store.

import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import MoveToReferralManagement from '../../components/modal/MoveToReferralManagement';
import {
  getReferralIngestionTargets,
  moveRecordToReferralManagement,
} from '../../actions/records';

class MoveToReferralManagementDialog extends Component {
  render() {
    return (
      <div>
        <MoveToReferralManagement {...this.props} />
      </div>
    );
  }
}

MoveToReferralManagementDialog.propTypes = {
  getReferralIngestionTargets: PropTypes.func.isRequired,
  moveRecordToReferralManagement: PropTypes.func.isRequired,
};

export default connect((state) => ({
  defaultFaxNumber: state.auth.data.defaultFaxNumber,
}), {
  getReferralIngestionTargets,
  moveRecordToReferralManagement,
})(MoveToReferralManagementDialog);
